export default __webpack_public_path__ + "static/media/nft.102864f0.png";